<script lang="ts" setup>
  import { ref, computed, defineProps, defineEmits } from 'vue'

  // 定义 props
  const props = defineProps({
    type: {
      type: String,
      default: 'success',
      validator: (value: string) => ['success', 'error', 'warning', 'text'].includes(value)
    },
    backgroundColor: {
      type: String,
      default: '#333'
    },
    message: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      default: 3000
    },
    // 定位相关属性
    targetElement: {
      type: String,
      default: null
    },
    offset: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    }
  })

  // 定义 emit
  const emit = defineEmits(['close'])

  // 控制 Toast 的显示和隐藏
  const visible = ref(true)

  // 计算 Toast 位置
  const toastStyle = computed(() => {
    // 如果指定了目标元素，相对于目标元素定位
    if (props.targetElement) {
      const target = document.querySelector(props.targetElement) as HTMLElement
      if (target) {
        const rect = target.getBoundingClientRect()
        const offset = props.offset || { x: 0, y: 0 }

        return {
          top: `${rect.top + offset.y}px`,
          left: `${rect.left + rect.width / 2 + offset.x}px`
        }
      }
    }
    return {}
  })

  // 自动关闭 Toast
  setTimeout(() => {
    visible.value = false
    emit('close')
  }, props.duration)
</script>

<template>
  <transition name="fade">
    <div
      v-if="visible"
      :style="{
        backgroundColor: backgroundColor,
        ...toastStyle
      }"
      :class="['toast', type]"
    >
      <span v-if="props.type === 'success'" class="toast-icon hitems-toast-success"></span>
      <span v-if="props.type === 'warning'" class="toast-icon hitems-tishi"></span>
      {{ message }}
    </div>
  </transition>
</template>

<style lang="stylus" scoped>
  .toast
      position fixed
      top 90px
      left 50%
      display flex
      align-items center;
      transform translateX(-50%)
      max-width 69rem
      padding: 5px 14px;
      border-radius 4rem
      color #fff
      background-color #333
      font-size 14px;
      line-height 1.5;
      z-index 1500;
      box-shadow 0 0.4rem 1rem rgba(0, 0, 0, 0.15)
      white-space nowrap

      .toast-icon
          font-size clamp(16px,2.2rem,22px)
          margin-right clamp(3px,0.5rem,5px)
          color #fff
      .close
          margin-left 3.5rem
          font-weight bold
          float right
          font-size 2.2rem
          cursor pointer
          transition color 0.3s
          &:hover
              color #000
  .fade-enter-active, .fade-leave-active {
      transition: opacity 0.3s;
  }

  .fade-enter, .fade-leave-to {
      opacity: 0;
  }
</style>
